export enum Brand {
  Very = "very",
  VeryIE = "veryireland",
  Littlewoods = "littlewoods",
}

// Type for all possible brand values in our application
export type BrandValue = `${Brand}`;

// Type mapping for Fuse Design System brands
export type FuseBrand = "default" | "littlewoods" | "very";

// Define PageType if it doesn't exist
export type PageType = string;

export interface GlobalConfig {
  brand: Brand;
  pageType: PageType;
  searchTerm?: string;
}

export interface SimpleHeaderProps {
  brand: "very" | "veryireland" | "littlewoods";
  environment: string;
}

export interface Split {}

// One department
export interface Department {
  name: string;
  link: string;
  splitsCount: number;
  splits: Split[];
}

// Full response structure
export interface DepartmentResponse {
  totalDepartments: number;
  departments: Department[];
}

export interface ComplexHeaderProps {
  brand: "very" | "veryireland" | "littlewoods";
  environment?: string;
  // Icon-related props
  onAccountClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  onMyOffersClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  onSavedClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  onBasketClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}
